import { observer } from 'mobx-react';
import * as React from 'react';
import ReactModal from 'react-modal';

const styles = require('./admin-modal.css');

export interface AdminModalProps extends ReactModal.Props {
  message?: boolean;
}

/**
 * Modal - SkillSeeker modal, doesn't cover the header
 */
@observer
export class AdminModal extends React.Component<AdminModalProps> {
  render(): JSX.Element {
    return (
      <ReactModal
        className={this.props.message ? styles.messageContent : styles.content}
        overlayClassName={styles.overlay}
        {...this.props}
      >
        {this.props.children}
      </ReactModal>
    );
  }
}



// WEBPACK FOOTER //
// ./src/admin/ui/components/admin-modal/admin-modal.tsx